/*
 * The panel is its own layout container (`APP-016`).
 *
 * The three figures used to go side by side at a 48rem *viewport*. `contracts/design/app-desk/`
 * puts this panel in a 22.5rem rail beside the bid form, where a wide viewport says nothing
 * about the room the figures have — and three columns in a 360px rail pushed the grid track
 * out past the page, which `e2e/tests/surface-chrome.spec.ts` caught as horizontal overflow.
 * The breakpoint below is therefore a container query: it asks how much room this panel has,
 * which is the question it was always trying to ask.
 */
.panel {
  display: grid;
  gap: var(--space-5);
  container-type: inline-size;
}

.figures {
  display: grid;
  gap: var(--space-5);
}

/* A ruled ledger: each figure sits in its own column, divided by the same hairline the
 * board uses. On narrow screens the columns become rows and the rule moves with them. */
.figure {
  display: grid;
  gap: var(--space-1);
  align-content: start;
  padding-block-start: var(--space-4);
  border-block-start: 1px solid var(--border);
}

.figure:first-child {
  padding-block-start: 0;
  border-block-start: 0;
}

.label {
  font-family: var(--font-figure);
  font-size: var(--text-xs);
  font-weight: 500;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.value {
  display: grid;
  gap: var(--space-2);
  margin: 0;
}

.amount {
  font-size: var(--text-xl);
  font-weight: 500;
  line-height: var(--leading-tight);
}

/* Available is the only figure a founder can act on, so it is the one that carries size. */
.lead .amount {
  font-size: var(--text-3xl);
  color: var(--accent);
}

.note {
  color: var(--text-muted);
  font-size: var(--text-sm);
  max-inline-size: var(--measure);
}

.empty,
.terms {
  color: var(--text-muted);
  font-size: var(--text-sm);
  max-inline-size: var(--measure);
}

.terms {
  padding-block-start: var(--space-4);
  border-block-start: 1px solid var(--border);
}

@container (min-width: 34rem) {
  .figures {
    grid-template-columns: 1.4fr 1fr 1fr;
    gap: var(--space-6);
  }

  .figure {
    padding-block-start: 0;
    padding-inline-start: var(--space-5);
    border-block-start: 0;
    border-inline-start: 1px solid var(--border);
  }

  .figure:first-child {
    padding-inline-start: 0;
    border-inline-start: 0;
  }
}
